export default {
  revenurActivity: {
    tab1:'模板',
    tab2:'个人榜单奖励配置',
    tab3:'积分奖励配置',
    tab4:'房间榜单奖励配置',
    tab5:'跳转模块',
    tab6:'充值梯度奖励配置',
    tab7:'首充奖励配置',
    tab8:'抽奖配置',

    title1:'新建模板',
    title2:'编辑模板',
    title3:'新建奖励',
    title4:'编辑奖励',
    title5:'查看奖励',

    watch:'查看',

    activityId:'活动ID',
    start_time:'开始时间',
    end_time:'结束时间',
    tempId:'模板ID',
    rankListId:'榜单奖励ID',
    integralId:'积分奖励ID',
    activityTemp:'活动模板',
    activityThem:'活动主题',
    operationName:'最后操作人',

    language1:'阿语',
    language2:'波斯语',
    language3:'土语',
    language4:'阿塞拜疆语',
    language5:'印尼语',
    language6:'英语',
    language7:'印地语',
    language8:'西语',
    language9:'葡语',

    addRankTop:'新增排名奖励',
    copyRankTop:'复制排名奖励',
    delRankTop:'删除奖励',

    prizeImg:'奖励图片',

    close:'关闭',
  }
}



// WEBPACK FOOTER //
// ./src/language/revenueActivity-zh-cn.js